<template lang="pug">
  div
    div.label.basic600--text.text-uppercase {{ $t('payment_method') }}
    div.mt-2
      y-checkbox(v-model="onlineBanking" :color="$vuetify.theme.themes[$theme].info500")
        template(v-slot:label)
          div.p2.my-auto {{ $t('paid_online') }}
    div.mt-2
      y-checkbox(v-model="manualTransfer" :color="$vuetify.theme.themes[$theme].info500")
        template(v-slot:label)
          div.p2.my-auto {{ $t('manual_bank_transfer') }}
    div.mt-2
      y-checkbox(v-model="cashOnDelivery" :color="$vuetify.theme.themes[$theme].info500")
        template(v-slot:label)
          div.p2.my-auto {{ $t('cash_on_delivery') }}
    div.mt-2
      y-checkbox(v-model="payAtShop" :color="$vuetify.theme.themes[$theme].info500")
        template(v-slot:label)
          div.p2.my-auto {{ $t('pay_at_shop') }}
</template>

<script>
export default {
  name: 'PaymentOrder',
  props: ['parentPaymentOrder'],
  data: () => ({
    onlineBanking: null,
    manualTransfer: null,
    cashOnDelivery: null,
    payAtShop: null,
  }),
  computed: {
    paymentOrder: {
      get () {
        return this.parentPaymentOrder
      },
      set (newValue) {
        this.$emit('update:parentPaymentOrder', newValue)
      }
    },
    selectedPayment () {
      let data = []
      if (this.onlineBanking) {
        data.push({ name: 'Paid online', value: 'paid_online' })
      }
      if (this.manualTransfer) {
        data.push({ name: 'Manual bank transfer', value: 'manual_bank_transfer' })
      }
      if (this.cashOnDelivery) {
        data.push({ name: 'Cash on delivery', value: 'cod' })
      }
      if (this.payAtShop) {
        data.push({ name: 'Pay at shop', value: 'pay_at_shop' })
      }
      return data
    }
  },
  watch: {
    selectedPayment (val) {
      this.paymentOrder = val
    },
    paymentOrder: {
      immediate: true,
      handler (val) {
        if (val.length > 0) {
          if (val.filter(f => f.value === 'paid_online').length > 0) {
            this.onlineBanking = true
          }
          if (val.filter(f => f.value === 'manual_bank_transfer').length > 0) {
            this.manualTransfer = true
          }
          if (val.filter(f => f.value === 'cod').length > 0) {
            this.cashOnDelivery = true
          }
          if (val.filter(f => f.value === 'pay_at_shop').length > 0) {
            this.payAtShop = true
          }
        } else {
          this.onlineBanking = false,
          this.manualTransfer = false,
          this.cashOnDelivery = false,
          this.payAtShop = false
        }
      }
    }
  }
}
</script>

<i18n>
{
  "en": {
    "paid_online": "Paid online",
    "manual_bank_transfer": "Manual bank transfer",
    "pay_at_shop": "Pay at shop"
  },
  "id": {
    "paid_online": "Pembayaran Online",
    "manual_bank_transfer": "Pembayaran manual transfer",
    "pay_at_shop": "Bayar di toko"
  }
}
</i18n>